import { ElementRef, HostListener, Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import {
  SetActivitiesAssignmentWindowWidth,
  SetWindowWidth,
} from '@wilson/shift-timeline/state';

@Injectable({
  providedIn: 'root',
})
export class GanttModalBaseService {
  private readonly store = inject(Store);

  public findStaffWrapper!: ElementRef<HTMLDivElement>;
  public isAssignStaffModal!: boolean;

  @HostListener('window:resize')
  onResize() {
    this.updateModalWidth();
  }

  public updateModalWidth() {
    const windowWidth = this.findStaffWrapper.nativeElement.clientWidth;
    if (windowWidth) {
      if (this.isAssignStaffModal) {
        this.store.dispatch(new SetWindowWidth({ width: windowWidth }));
      } else {
        this.store.dispatch(
          new SetActivitiesAssignmentWindowWidth({ width: windowWidth }),
        );
      }
    }
  }
}
